import { render, staticRenderFns } from "./PasswordResetCompletePage.vue?vue&type=template&id=143355d6"
import script from "./PasswordResetCompletePage.vue?vue&type=script&lang=ts"
export * from "./PasswordResetCompletePage.vue?vue&type=script&lang=ts"
import style0 from "./PasswordResetCompletePage.vue?vue&type=style&index=0&id=143355d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports